import type { SiteState } from '../../types';

const selectSiteName = (site: SiteState) => site.siteName;

export default {
  selectSiteName,
};
